import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'text',
        name: 'name',
        title: i18n.t('customer.users.name'),
        rules: {required: true, min: 3 },
        modal: ['name'],
        data: ['name'],
        additionalButton: false,
        checkBox: false,
    },
    {
        type: 'masked',
        name: 'phone_no',
        title: i18n.t('customer.wizzard.phoneNo'),
        rules: { required: true, regex: /^(\+\s\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/ },
        options: false,
        mask:"\+\ 11 (111) 111 1111",
        modal: ['phone_no'],
        data: ['phone_no'],
        additionalButton: false,
        checkBox: false
    }, 
    {
        type: 'text',
        name: 'email',
        title: i18n.t('customer.wizzard.email'),
        rules: {required: true, email: true },
        modal: ['email'],
        data: ['email'],
        additionalButton: false,
        checkBox: false,
    },
    {
        type: 'text',
        name: 'task',
        title: i18n.t('customer.users.task'),
        rules: {required: true, min: 3},
        modal: ['task'],
        data: ['task'],
        additionalButton: false,
        checkBox: false,
    }
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Customer/forms/authoriesForm.js